var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.55556C17 6.52 13.4178 8.11111 9 8.11111C4.58222 8.11111 1 6.52 1 4.55556M17 4.55556C17 2.59111 13.4178 1 9 1C4.58222 1 1 2.59111 1 4.55556M17 4.55556V9M1 4.55556V9M17 9C17 10.9644 13.4178 12.5556 9 12.5556C4.58222 12.5556 1 10.9644 1 9M17 9V13.4444C17 15.4089 13.4178 17 9 17C4.58222 17 1 15.4089 1 13.4444V9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.b3e1185b873a280551b121d96d255bcd.svg";
export { ForwardRef as ReactComponent };